import { render, staticRenderFns } from "./wyModalEditObjective.vue?vue&type=template&id=0aa6da77&"
import script from "./wyModalEditObjective.vue?vue&type=script&lang=js&"
export * from "./wyModalEditObjective.vue?vue&type=script&lang=js&"
import style0 from "./wyModalEditObjective.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports